import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function PtAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" style={{width: "25%"}}></th>
                                    <th scope="col" style={{width: "35%"}}>
                                        Clienti iscritti al Cigno
                                    </th>
                                    <th scope="col" style={{width: "35%"}}>
                                        Clienti NON iscritti al Cigno
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Carnet 10 lezioni</th>
                                    <td className={"data-cell"}>450€</td>
                                    <td className={"data-cell"}>550€</td>
                                </tr>
                                <tr>
                                    <th scope="row">Carnet 5 lezioni</th>
                                    <td className={"data-cell"}>250€</td>
                                    <td className={"data-cell"}>275€</td>
                                </tr>
                                <tr>
                                    <th scope="row">Lezione singola</th>
                                    <td className={"data-cell"}>60€</td>
                                    <td className={"data-cell"}>70€</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <br/>
                            <AllertIscrizione />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PtAccordionPrezzi